export const modesButtons = {
  rack: ['regular', 'emergency', 'free', 'test'],
  app: ['regular', 'blocked'],
};

export const modes = {
  rack: {
    regular: 'Штатный',
    offline: 'Отключен',
    test: 'Сервисный',
    free: 'Свободный',
    emergency: 'Блокированный',
  },
  app: {
    regular: 'Штатный',
    offline: 'Отключен',
    blocked: 'Блокированный',
    emergency: 'Ошибка',
    app_not_work: 'Ошибка оборудования АПП',
  },
};

export const helpItems = {
  rack: [
    {
      icon: '/images/normal.png',
      title: 'Штатный',
      info: 'Работа устройства в соответствии с алгоритмами системы',
    },
    {
      icon: '/images/blocked.png',
      title: 'Блокированный',
      info: 'Оборудование выключено, проезд закрыт, шлагбаум опущен',
    },
    {
      icon: '/images/free.png',
      title: 'Свободный',
      info: 'Проезд открыт, шлагбаум поднят, для проезда ТС в экстренных случаях',
    },
    {
      icon: '/images/service.png',
      title: 'Сервисный',
      info: 'Тестирование системы, шлагбаумы поднимаются при въезде автомобиля на индукционную петлю',
    },
  ],
  app: [
    {
      icon: '/images/normal.png',
      title: 'Штатный',
      info: 'Работа устройства в соответствии с алгоритмами системы',
    },
    {
      icon: '/images/blocked.png',
      title: 'Блокированный',
      info: 'Платежный терминал заблокирован оператором',
    },
  ],
};
